// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"DepositFailedDefault_closeButton__HDuxz"};